import { render, staticRenderFns } from "./CrmLinking.vue?vue&type=template&id=1ff518de&"
import script from "./CrmLinking.vue?vue&type=script&setup=true&lang=js&"
export * from "./CrmLinking.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports